import {
  GET_REQUEST_DETAIL,
  GET_REQUEST_DETAIL_SUCCESS,
  GET_REQUEST_DETAIL_FAILURE,
} from 'store/requestDetail/requestDetailAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const requestDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REQUEST_DETAIL:
      return { ...state, loading: true };
    case GET_REQUEST_DETAIL_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_REQUEST_DETAIL_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default requestDetailReducer;
